import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../services/baseQuery";

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery:appBaseQuery,
  tagTypes: ["Analytics"],
  endpoints: (builder) => ({
    // GET analytics summary
    getAnalyticsSummary: builder.query({
      query: () => `analytics/`,
      providesTags: ["Analytics"],
    }),

    getConsumerInformation: builder.query({
      query: ({ page = 1, limit = 10, date, shift, consumer_type }) => {
        let queryString = `analytics/consumer-information/?page=${page}&limit=${limit}`;
        if (date) queryString += `&date=${date}`;
        if (shift) queryString += `&shift=${shift}`;
        if (consumer_type) queryString += `&consumer_type=${consumer_type}`;
        return queryString;
      },
      providesTags: ["Analytics"],
    }),

    addConsumer: builder.mutation({
      query: (body) => ({
        url: "consumers/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Analytics"],
    }),

    exportAnalyticsExcel: builder.query({
      query: ({ date, shift, consumer_type } = {}) => {
        let queryString = `analytics/analytics/export/excel?`;
        if (date) queryString += `&date=${date}`;
        if (shift) queryString += `&shift=${shift}`;
        if (consumer_type) queryString += `&consumer_type=${consumer_type}`;
        return {
          url: queryString,
          responseHandler: (response) => response.blob(), 
        };
      },
    }),
  }),
});

export const {
  useGetAnalyticsSummaryQuery,
  useGetConsumerInformationQuery,
  useLazyExportAnalyticsExcelQuery,
} = analyticsApi;
